import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSessionContext } from '@contexts';

const HomeSelector = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { session } = useSessionContext();

    useEffect(() => {
        const state = location.state as Record<string, unknown> | null;
        const destination = session?.isGuarantor ? `/guarantor` : `/payor`;
        navigate(destination, { replace: true, state });
    }, []);

    return (
        <div></div>
    );
};

export default HomeSelector;
